// Name
export const signinName = 'sign in start'

export type Name = typeof signinName

// Region
export const signinRegion = 'top nav'

export type Region = typeof signinRegion

// Type
export const linkType = 'link'

export type Type = typeof linkType

export type SigninStartPayload = {
  name?: Name
  region_name?: Region
  type?: Type
}
